import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface DetailChipProps {
  icon: IconProp
  label: string
  value: string
  highlight?: boolean
}

export const DetailChip = ({ icon, label, value, highlight = false }: DetailChipProps) => (
  <div
    className={`rounded-lg border-2 px-3 py-3 text-sm ${highlight ? "border-orange-200 bg-orange-50" : "border-slate-200 bg-white"}`}
  >
    <div className="flex items-center gap-2 text-xs uppercase text-slate-500">
      <FontAwesomeIcon icon={icon} />

      <span>{label}</span>
    </div>

    <p className="mt-1 break-words font-semibold text-slate-900">{value}</p>
  </div>
)
